import React from 'react';

interface DashboardLayoutProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  sidebar?: React.ReactNode;
  statsPanel?: React.ReactNode;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  header,
  sidebar,
  statsPanel,
}) => {
  return (
    <div className="min-h-screen bg-navy-blue">
      {/* Header */}
      {header && (
        <header className="bg-navy-blue text-white shadow-lg border-b border-medium-gray">
          <div className="max-w-full px-6 py-4">
            {header}
          </div>
        </header>
      )}

      {/* Main Content Area */}
      <div className="flex h-[calc(100vh-80px)]">
        {/* Sidebar (Filter Panel) */}
        {sidebar && (
          <aside className="w-80 bg-navy-blue border-r border-medium-gray overflow-y-auto">
            {sidebar}
          </aside>
        )}

        {/* Main Canvas */}
        <main className="flex-1 overflow-auto bg-navy-blue">
          {children}
        </main>

        {/* Stats Panel (Right Sidebar) */}
        {statsPanel && (
          <aside className="w-80 bg-navy-blue border-l border-medium-gray overflow-y-auto">
            {statsPanel}
          </aside>
        )}
      </div>
    </div>
  );
};
